import React from "react";
import "./FlightSearchSummary.css";

export default function FlightSearchSummary({ search, onEditSearch }) {
  if (!search) return null;
  return (
    <section className="fe2-summary" aria-label="סיכום חיפוש">
      <div className="fe2-summary__facts">
        <div className="fe2-summary__route">
          <div className="fe2-summary__place">
            <strong className="fe2-summary__iata fe2-ltr">{search.origin}</strong>
            <span className="fe2-summary__city">{search.originCity}</span>
          </div>
          <button type="button" className="fe2-summary__swap" aria-label="החלף מוצא ויעד">
            ⇄
          </button>
          <div className="fe2-summary__place">
            <strong className="fe2-summary__iata fe2-ltr">{search.destination}</strong>
            <span className="fe2-summary__city">{search.destinationCity}</span>
          </div>
        </div>

        <div className="fe2-summary__meta">
          <div className="fe2-summary__item">
            <span className="fe2-summary__item-label">תאריכים</span>
            <span className="fe2-summary__dates">
              <strong className="fe2-summary__item-value fe2-ltr">
                {search.departDateLabel}
                {search.returnDateLabel ? ` – ${search.returnDateLabel}` : ""}
              </strong>
              {search.stayLabel ? (
                <span className="fe2-summary__stay">{search.stayLabel}</span>
              ) : null}
            </span>
          </div>
          <div className="fe2-summary__item">
            <span className="fe2-summary__item-label">נוסעים</span>
            <strong className="fe2-summary__item-value">{search.passengersLabel}</strong>
          </div>
          <div className="fe2-summary__item">
            <span className="fe2-summary__item-label">סוג נסיעה</span>
            <strong className="fe2-summary__item-value">{search.tripTypeLabel}</strong>
          </div>
        </div>
      </div>

      <button type="button" className="fe2-summary__edit" onClick={onEditSearch}>
        עריכת חיפוש
      </button>
    </section>
  );
}
